import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/rice.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "What is the RICE scoring model for prioritization?", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "The RICE scoring model is a prioritization framework designed to help product managers determine which products, features, and other initiatives to put on their roadmaps by scoring these items according to four factors. These factors, which form the acronym RICE, are reach, impact, confidence, and effort.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Using a scoring model such as RICE can offer product teams a three-fold benefit. First, it can enable product managers to make better-informed decisions, minimize personal biases in decision making, and help them defend their priorities to other stakeholders such as the executive staff.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "How does the RICE scoring model work?", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "To use the RICE scoring model, you evaluate each of your competing ideas (new products, product extensions, features, etc.) by scoring them according to the following formula: ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "img-fluid w-100",
  alt: "rice diagram"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Reach", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "The first factor in determining your RICE score is to get a sense of how many people you estimate your initiative will reach in a given timeframe.", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "You have to decide both what “reach” means in this context and the timeframe over which you want to measure it. You can choose any time period—one month, a quarter, etc.—and you can decide that reach will refer to the number of customer transactions, free-trial signups, or how many existing users try your new feature.", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Your reach score will be the number you’ve estimated. For example, if you expect your project will lead to 150 new customers within the next quarter, your reach score is 150. On the other hand, if you estimate your project will deliver 1,200 new prospects to your trial-download page within the next month, and that 30% of those prospects will sign up, your reach score is 360.", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", null, "Impact", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Impact can reflect a quantitative goal, such as how many new conversions for your project will result in when users encounter it, or a more qualitative objective such as increasing customer delight.", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Even when using a quantitative metric (“How many people who see this feature will buy the product?”), measuring impact will be difficult, because you won’t necessarily be able to isolate your new project as the primary reason (or even a reason at all) for why your users take action. If measuring the impact of a project after you’ve collected the data will be difficult, you can assume that estimating it beforehand will also be a challenge.", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", null, "Confidence", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "The confidence component of your RICE score helps you control for projects in which your team has data to support one factor of your score but is relying more on intuition for another factor.", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "For example, if you have data backing up your reach estimate but your impact score represents more of a gut feeling or anecdotal evidence, your confidence score will help account for this.", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", null, "Effort", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "We have discussed alll of the factors to this point—reach, impact, confidence—represent the numerators in the RICE scoring equation. Effort represents the denominator.", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "In other words, if you think of RICE as a cost-benefit analysis, the other three components are all potential benefits while effort is the single score that represents the costs.", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "Quantifying effort in this model is similar to scoring reach. You simply estimate the total number of resources (product, design, engineering, testing, etc.) needed to complete the initiative over a given period of time—typically “person-months”—and that is your score.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MDBCol = _resolveComponent("MDBCol")!
  const _component_MDBRow = _resolveComponent("MDBRow")!
  const _component_MDBBtn = _resolveComponent("MDBBtn")!
  const _component_MDBContainer = _resolveComponent("MDBContainer")!

  return (_openBlock(), _createBlock(_component_MDBContainer, { class: "mt-3" }, {
    default: _withCtx(() => [
      _createVNode(_component_MDBRow, null, {
        default: _withCtx(() => [
          _createVNode(_component_MDBCol, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_MDBRow, null, {
        default: _withCtx(() => [
          _createVNode(_component_MDBCol, {
            md: "6",
            offset: "3"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_MDBRow, null, {
        default: _withCtx(() => [
          _createVNode(_component_MDBCol, null, {
            default: _withCtx(() => [
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              _hoisted_19,
              _hoisted_20
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (!_ctx.$rbac.hasPermission('project.view'))
        ? (_openBlock(), _createBlock(_component_MDBRow, {
            key: 0,
            class: "mb-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_MDBCol, null, {
                default: _withCtx(() => [
                  _createVNode(_component_MDBBtn, {
                    color: "primary",
                    size: "lg",
                    onClick: _ctx.doLogin
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Login to start")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}